import { useSelector } from 'react-redux';
import { getLocationPayload } from '@/redux/location/selectors';

export function useParams<T extends Record<string, unknown>>(): T {
  return useSelector(getLocationPayload) as T;
}
